import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'externalUrl',
  standalone: false,
})
export class ExternalUrlPipe implements PipeTransform {
  transform(url?: string): string {
    if (!url) return '';
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, '');

    if (/^(:\/\/)/.test(newUrl)) {
      return `http${newUrl}`;
    }
    if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
      return `https://${newUrl}`;
    }

    return newUrl;
  }
}
